import { jsxs, jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material/styles';
import { Box, CircularProgress } from '@mui/material';
import { Logo } from './Logo.js';

const PREFIX = 'SplashScreen';
const classes = {
    root: `${PREFIX}-root`,
    logo: `${PREFIX}-logo`,
};
const Root = styled('div')(({ theme }) => ({
    [`&.${classes.root}`]: {
        alignItems: 'center',
        backgroundColor: theme.palette.background.default,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'center',
        left: 0,
        padding: theme.spacing(3),
        position: 'fixed',
        top: 0,
        width: '100%',
        zIndex: 2000,
    },
    [`& .${classes.logo}`]: {
        width: 200,
        maxWidth: '100%',
    },
}));
const SplashScreen = (props) => (jsxs(Root, Object.assign({ className: classes.root }, props, { children: [jsx(Box, Object.assign({ display: "flex", justifyContent: "center", mb: 6 }, { children: jsx(Logo, { className: classes.logo }) })), jsx(CircularProgress, {})] })));

export { SplashScreen };
